import "../styles/personal-chart.css";
import { useState } from "react";
import TriangleLoading from "../compoments/widget/TriangleLoading";
import OpenAIService from "../service/openai-service";

const PersonalChartComponent = () => {
  const [gender, setGender] = useState("1");
  const [year, setYear] = useState(2025);
  const [month, setMonth] = useState(1);
  const [day, setDay] = useState(1);
  const [hour, setHour] = useState("12");
  const [minute, setMinute] = useState("0");
  const [activeTxt, setActiveTxt] = useState("取得你的專屬命盤");
  const [personalChart, setPersonalChart] = useState(null);
  const [isDisabled, setIsDisabled] = useState(false);

  //０:起始輸入畫面 1:結果畫面 2: loading 畫面
  const [state, setState] = useState("0");

  const yearOptions = [];

  const currentYear = new Date().getFullYear(); // 取得今年西元年

  for (let y = 1912; y <= currentYear; y++) {
    const roc = y - 1911;
    yearOptions.push(
      <option key={y} value={y}>
        民國 {roc}（西元 {y}）
      </option>
    );
  }
  const monthOptions = [];

  for (let m = 1; m <= 12; m++) {
    monthOptions.push(
      <option key={m} value={m}>
        {m}
      </option>
    );
  }

  const dayOptions = [];

  for (let m = 1; m <= 31; m++) {
    dayOptions.push(
      <option key={m} value={m}>
        {m}
      </option>
    );
  }

  const hourOptions = [];

  for (let m = 0; m <= 23; m++) {
    hourOptions.push(
      <option key={m} value={m}>
        {m.toString().padStart(2, "0")}
      </option>
    );
  }

  const minuteptions = [];

  for (let m = 0; m <= 59; m++) {
    minuteptions.push(
      <option key={m} value={m}>
        {m.toString().padStart(2, "0")}
      </option>
    );
  }

  // const [isMobile, setIsMobile] = useState(window.innerWidth <= 1024);

  // useEffect(() => {
  //   const handleResize = () => {
  //     setIsMobile(window.innerWidth <= 1024);
  //   };

  //   window.addEventListener("resize", handleResize);
  //   return () => window.removeEventListener("resize", handleResize);
  // }, []);

  // useEffect(() => {
  //   const handlePopState = () => {
  //     setState((prev) => {
  //       if (prev === "1") {
  //         // 回到初始畫面
  //         return "0";
  //       }
  //       return prev; // 如果是 "0" 就保持不變（真正返回瀏覽器上一頁）
  //     });
  //   };

  //   window.addEventListener("popstate", handlePopState);
  //   return () => {
  //     window.removeEventListener("popstate", handlePopState);
  //   };
  // }, []);

  const getPersonalChart = async (e) => {
    setState("2");
    setActiveTxt("個人命盤分析中...");
    setIsDisabled(true);

    await OpenAIService.enableChartService(
      year,
      month,
      day,
      hour,
      minute,
      gender
    );

    startPollingChart();
  };

  let pollingInterval = null;

  const startPollingChart = () => {
    setTimeout(() => {
      pollingInterval = setInterval(async () => {
        try {
          const res = await OpenAIService.getUserChart(
            `${year}-${month}-${day}-${hour}-${minute}-${gender}`
          );

          // ✅ 當 data 有資料時，停止輪詢
          if (res && res.data.data != null) {
            clearInterval(pollingInterval);
            pollingInterval = null;
            setState("1");
            setActiveTxt("取得你的專屬命盤");
            setPersonalChart(res.data.data);
            setIsDisabled(false);
          }
        } catch (err) {
          console.error("輪詢失敗：", err);
          // 可以選擇是否停止輪詢
        }
      }, 3000); // 每 3 秒打一次
    }, 3000); // 第一次延遲 3 秒才開始
  };

  // const stopPollingChart = () => {
  //   if (pollingInterval) {
  //     clearInterval(pollingInterval);
  //     pollingInterval = null;
  //   }
  // };

  // useEffect(() => {
  //   return () => {
  //     stopPollingChart(); // ❗清掉 interval 避免殘留
  //   };
  // }, []);

  return (
    <div className="personal-chart">
      <main>
        <div className="display">
          <div className="input">
            <div className="title-hint">
              <div className="tag"></div>
              <p>個人命盤分析</p>
            </div>

            <p className="select-hint">性別</p>

            <div className="select-radio">
              <div className="option">
                <input
                  type="radio"
                  name="gender"
                  id="male"
                  value="1"
                  checked={gender === "1"}
                  onChange={() => setGender("1")}
                />
                <label htmlFor="male">男性</label>
              </div>

              <div className="option">
                <input
                  type="radio"
                  name="gender"
                  id="female"
                  value="0"
                  checked={gender === "0"}
                  onChange={() => setGender("0")}
                />
                <label htmlFor="female">女性</label>
              </div>
            </div>

            <div className="select-birth">
              <div className="select-opt  select-opt-year">
                <div className="select-tag">
                  <p className="tag">年份</p>
                  <i class="bi bi-caret-down-fill"></i>
                </div>

                <select
                  id="year-select"
                  className="form-select"
                  style={{
                    appearance: "none",
                    WebkitAppearance: "none",
                    MozAppearance: "none",
                    backgroundImage: "none",
                    boxShadow: "none", // 移除陰影效果
                  }}
                  value={year}
                  onChange={(e) => setYear(parseInt(e.target.value))}
                >
                  {yearOptions}
                </select>
              </div>

              <div className="space"></div>

              <div className="select-opt">
                <div className="select-tag">
                  <p className="tag">月份</p>
                  <i class="bi bi-caret-down-fill"></i>
                </div>

                <select
                  id="month-select"
                  className="form-select"
                  style={{
                    appearance: "none",
                    WebkitAppearance: "none",
                    MozAppearance: "none",
                    backgroundImage: "none",
                    boxShadow: "none", // 移除陰影效果
                  }}
                  value={month}
                  onChange={(e) => setMonth(parseInt(e.target.value))}
                >
                  {monthOptions}
                </select>
              </div>

              <div className="space"></div>

              <div className="select-opt">
                <div className="select-tag">
                  <p className="tag">日期</p>
                  <i class="bi bi-caret-down-fill"></i>
                </div>
                <select
                  id="day-select"
                  className="form-select"
                  style={{
                    appearance: "none",
                    WebkitAppearance: "none",
                    MozAppearance: "none",
                    backgroundImage: "none",
                    boxShadow: "none", // 移除陰影效果
                  }}
                  value={day}
                  onChange={(e) => setDay(parseInt(e.target.value))}
                >
                  {dayOptions}
                </select>
              </div>
            </div>

            <div className="select-birth">
              <div className="select-opt">
                <div className="select-tag">
                  <p className="tag">出生-時</p>
                  <i class="bi bi-caret-down-fill"></i>
                </div>

                <select
                  id="hour-select"
                  className="form-select"
                  style={{
                    appearance: "none",
                    WebkitAppearance: "none",
                    MozAppearance: "none",
                    backgroundImage: "none",
                    boxShadow: "none", // 移除陰影效果
                  }}
                  value={hour}
                  onChange={(e) => setHour(parseInt(e.target.value))}
                >
                  {hourOptions}
                </select>
              </div>

              <div className="space time-space"></div>

              <div className="select-opt">
                <div className="select-tag">
                  <p className="tag">出生-分</p>
                  <i class="bi bi-caret-down-fill"></i>
                </div>

                <select
                  id="minute-select"
                  className="form-select"
                  style={{
                    appearance: "none",
                    WebkitAppearance: "none",
                    MozAppearance: "none",
                    backgroundImage: "none",
                    boxShadow: "none", // 移除陰影效果
                  }}
                  value={minute}
                  onChange={(e) => setMinute(parseInt(e.target.value))}
                >
                  {minuteptions}
                </select>
              </div>
            </div>

            <div className="start-analytics">
              <button onClick={getPersonalChart} disabled={isDisabled}>
                {activeTxt}
              </button>
            </div>
          </div>

          {state === "1" && (
            <div className="result">
              <section className="aspect-block">
                <h2 className="aspect-title">😀 個性</h2>
                <p className="aspect-content">
                  <strong>八字分析：</strong>
                  {personalChart.personality.bazi}
                </p>
                <p className="aspect-content">
                  <strong>紫薇分析：</strong>
                  {personalChart.personality.ziwei}
                </p>
                <p className="aspect-content">
                  <strong>綜合觀點：</strong>
                  {personalChart.personality.summary}
                </p>
              </section>

              <section className="aspect-block">
                <h2 className="aspect-title">💼 事業</h2>
                <p className="aspect-content">
                  <strong>八字分析：</strong>
                  {personalChart.career.bazi}
                </p>
                <p className="aspect-content">
                  <strong>紫薇分析：</strong>
                  {personalChart.career.ziwei}
                </p>
                <p className="aspect-content">
                  <strong>綜合觀點：</strong>
                  {personalChart.career.summary}
                </p>
              </section>

              <section className="aspect-block">
                <h2 className="aspect-title">❤️ 感情</h2>
                <p className="aspect-content">
                  <strong>八字分析：</strong>
                  {personalChart.love.bazi}
                </p>
                <p className="aspect-content">
                  <strong>紫薇分析：</strong>
                  {personalChart.love.ziwei}
                </p>
                <p className="aspect-content">
                  <strong>綜合觀點：</strong>
                  {personalChart.love.summary}
                </p>
              </section>

              <section className="aspect-block">
                <h2 className="aspect-title">🏃‍♀️ 健康</h2>
                <p className="aspect-content">
                  <strong>八字分析：</strong>
                  {personalChart.health.bazi}
                </p>
                <p className="aspect-content">
                  <strong>紫薇分析：</strong>
                  {personalChart.health.ziwei}
                </p>
                <p className="aspect-content">
                  <strong>綜合觀點</strong>
                  {personalChart.health.summary}
                </p>
              </section>

              <section className="aspect-block">
                <h2 className="aspect-title">💰 財運</h2>
                <p className="aspect-content">
                  <strong>八字分析：</strong>
                  {personalChart.wealth.bazi}
                </p>
                <p className="aspect-content">
                  <strong>紫薇分析：</strong>
                  {personalChart.wealth.ziwei}
                </p>
                <p className="aspect-content">
                  <strong>綜合觀點：</strong>
                  {personalChart.wealth.summary}
                </p>
              </section>

              <section className="aspect-block">
                <h2 className="aspect-title">🏠 家庭</h2>
                <p className="aspect-content">
                  <strong>八字分析：</strong>
                  {personalChart.family.bazi}
                </p>
                <p className="aspect-content">
                  <strong>紫薇分析：</strong>
                  {personalChart.family.ziwei}
                </p>
                <p className="aspect-content">
                  <strong>綜合觀點：</strong>
                  {personalChart.family.summary}
                </p>
              </section>

              <section className="aspect-block">
                <h2 className="aspect-title">🤼 人際</h2>
                <p className="aspect-content">
                  <strong>八字分析：</strong>
                  {personalChart.social.bazi}
                </p>
                <p className="aspect-content">
                  <strong>紫薇分析：</strong>
                  {personalChart.social.ziwei}
                </p>
                <p className="aspect-content">
                  <strong>綜合觀點：</strong>
                  {personalChart.social.summary}
                </p>
              </section>
            </div>
          )}

          {state === "2" && (
            <div className="loading">
              <TriangleLoading></TriangleLoading>
            </div>
          )}
        </div>
      </main>
    </div>
  );
};

export default PersonalChartComponent;
